import { useSelector } from "react-redux";
import styles from "./ExternalSuccess.module.scss";

const ExternalSuccess = () => {
  const externalApplicant = useSelector(
    (state) => state.applicant.externalApplicant
  );
  return (
    <div className={styles.successPageMain}>
      {externalApplicant ? (
        <>
          <div className={styles.successPage}>
            <div className={styles.applicantName}>
              {externalApplicant?.name},
            </div>
            <div className={styles.detailPart}>
              <p>
                Thank you for showing your interest in {externalApplicant?.companyName}.
              </p>
              <p>
                Our HR team will review your application and revert if your resume gets shortlisted.
              </p>
            </div>
          </div>
        </>
      ) : (
        <div className={styles.errorDetails}>
          <div className={styles.detailPart}>
            <p>Link has been expired, Please revisit the opening link.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExternalSuccess;
